import {
  AUTH,
  REGISTER,
  BLOGS,
  GET_HOHO_FAQS,
  HOHO_FARM,
  ADD,
  NEWS_LETTER,
  GET_HOHO_SITE_SETTINGS,
  CUSTOMER,
  WISH_LIST,
  REMOVE,
  URLS,
  BRANDS,
  CAMPAIGN,
  GET_CAMPAIGN,
  FIND_CAMPAIGN,
  DONATE,
  MAKE_DONATION,
  MEMBERSHIP,
  GET_MEMBERSHIP,
  EXTRA_CHARGES,
  FIND_MEMBERSHIP,
  CSA_PRODUCT_PRICE,
  PRODUCTS,
  DETAILS,
  REVIEWS,
  SUBMIT,
  RATING,
  UPDATE_PROFILE,
  ADDRESS,
  LIST,
  CHANGE_PASSWORD,
  ORDER,
  BLOG_DETAILS,
  CONTACT,
  CONTACTUS,
  FILTER_TYPES,
  CATEGORIES,
  MY_DONATION,
  FREQUENTLY_BOUGHT,
  MAKE_DEFAULT,
  GIFT_CODE,
  GET_GIFT_CODE,

  LOGIN,
  FORGOT,
  SITE_SETTINGS,
  DELETE,
  RESET_PASSWORD,
  PAGE,
  WISHLIST,
  PLACE,
  REMOVE_ALL,
  CUSTOMER_ID,
  COUPON,
  APPLY,
  EDIT_ADDRESS,
  BOOKMEMBERSHIP,
  GET_LOCATION,
  GET_KIGI_SOCIAL_MEDIA,
  GET_IMAGES,
  GALLERY,
  GET_ABOUT_US,
  GET_NEWS_LISTS,
  ORDER_LIST,
  MY_BOOKINGS_LIST,
  GET_MEMBERSHIP_BOOKING,
  PRODUCT_DATE,
  UPDATE_MEMBERSHIP,
  CANCEL_MEMBERSHIP,
  GET_MEMBERSHIP_BY_QR,
  UPDATE_FAMILY_MEMBERSHIP,

  // FROGOT_PASSWORD,
} from "../network/Endpoint";
import { data } from "../pages/OurDoners/OurDoners";

import {
  doGet,
  doPost,
  doPatch,
  doDelete,
  doPostProfilePictureUpload,
  doPut,
  doPutPictureUpload,
} from "./Config";

export const postSignUp = (data) => {
  return doPost(`${AUTH}${REGISTER}`, data);
};

export const postSignIn = (data) => {
  return doPost(`${AUTH}${LOGIN}`, { ...data });
};

export const forgotPasswordApi = (data) => {
  return doPost(`${AUTH}${FORGOT}`, data);
};

export const GetSiteSettingsApi = () => {
  return doGet(`${HOHO_FARM}${GET_HOHO_SITE_SETTINGS}`);
};

export const GetSocialMedia = () => {
  return doGet(`${HOHO_FARM}${GET_KIGI_SOCIAL_MEDIA}`);
};

export const GetGalleryImage = () => {
  return doGet(`${HOHO_FARM}${GALLERY}${GET_IMAGES}`);
};

export const GetAboutUs = () => {
  return doGet(`${GET_ABOUT_US}`);
};

export const GetNewsList = () => {
  return doGet(`${GET_NEWS_LISTS}`);
};

export const GetAllFilterApi = () => {
  return doGet(`${PRODUCTS}${FILTER_TYPES}`);
};

export const GetPlantsApi = (currentPage, data) => {
  return doGet(
    `${CATEGORIES}${PRODUCTS}${data?.name}${"?color"}=${
      data?.color ? data?.color : " "
    }${"&species"}=${data?.species ? data?.species : " "}${"&leaf_type"}=${
      data?.leaf_type ? data?.leaf_type : " "
    }${"&growth_rate"}=${
      data?.growth_rate ? data?.growth_rate : " "
    }${"&hardiness_zone"}=${
      data?.hardiness_zone ? data?.hardiness_zone : " "
    }${"&start_price"}=${
      data?.start_price ? data?.start_price : " "
    }${"&end_price"}=${
      data?.end_price ? data?.end_price : " "
    }${"&category_id"}=${data?.category ? data?.category : " "}${"&search"}=${
      data?.search ? data?.search : " "
    }${"&page"}=${currentPage}`
  );
};

export const GetBlogs = () => {
  return doGet(`${BLOGS}`);
};

export const GetCampaign = () => {
  return doGet(`${CAMPAIGN}${GET_CAMPAIGN}`);
};

export const UpdateProfile = (data, token) => {
  return doPostProfilePictureUpload(
    `${CUSTOMER}${UPDATE_PROFILE}`,
    data,
    token
  );
};

export const PostChangePassword = (data, token) => {
  return doPost(`${CUSTOMER}${CHANGE_PASSWORD}`, data, token);
};

export const MyDonations = (currentPage, token) => {
  return doGet(`${CUSTOMER}${MY_DONATION}${"?page"}=${currentPage}`, token);
};

export const GetCancellation = () => {
  return doGet(`${SITE_SETTINGS}?type=hoho-about-us`);
};



export const GetFaqs = () => {
  return doGet(`${HOHO_FARM}${GET_HOHO_FAQS}`);
};

export const PostNewsLetter = (data) => {
  return doPost(`${NEWS_LETTER}${ADD}`, data);
};

export const GetAllWishList = (current_page, token) => {
  return doGet(`${CUSTOMER}${WISH_LIST}`, token);
};

export const PostWishListDelete = (data, token) => {
  return doPost(`${CUSTOMER}${WISH_LIST}${REMOVE}`, data, token);
};

export const PostAddWishList = (data, token) => {
  return doPost(`${CUSTOMER}${WISH_LIST}${ADD}`, data, token);
};

export const GetCategories = () => {
  return doGet(`${CATEGORIES}`);
};

export const GetUrls = () => {
  return doGet(`${URLS}`);
};

export const GetBrands = () => {
  return doGet(`${BRANDS}`);
};

export const PostCampaignDetails = (id) => {
  return doPost(`${CAMPAIGN}${FIND_CAMPAIGN}${"/"}${id}`);
};

export const PostCampaignDonation = (data, token) => {
  return doPost(`${DONATE}${MAKE_DONATION}`, data, token);
};

export const GetMembership = () => {
  return doGet(`${MEMBERSHIP}${GET_MEMBERSHIP}`);
};

export const GetExtraCharges = () => {
  return doGet(`${MEMBERSHIP}${EXTRA_CHARGES}`);
};

export const GetMemberShipByQR = (data) => {
  return doPost(`${MEMBERSHIP}${GET_MEMBERSHIP_BY_QR}`, data);
};

export const GetMembershipBook = () => {
  return doGet(`${MEMBERSHIP}${GET_MEMBERSHIP_BOOKING}`);
};

export const GetMembershipLocation = () => {
  return doGet(`${MEMBERSHIP}${GET_LOCATION}`);
};

export const PostMembershipById = (id) => {
  return doPost(`${MEMBERSHIP}${FIND_MEMBERSHIP}/${id}`);
};

export const bookMemberShipPost = (data, token) => {
  return doPost(`${MEMBERSHIP}${BOOKMEMBERSHIP}`, data, token);
};

export const PostCSAProductPriceById = (id) => {
  return doPost(`${MEMBERSHIP}${CSA_PRODUCT_PRICE}/${id}`);
};

export const GetProductDetailsApi = (id) => {
  return doGet(`${PRODUCTS}${DETAILS}/${id}`);
};

export const PostProductReviewApi = (data, token) => {
  return doPost(`${PRODUCTS}${REVIEWS}${SUBMIT}`, data, token);
};

export const GetProductRatingApi = (id) => {
  return doGet(`${PRODUCTS}${RATING}/${id}`);
};

export const GetAllAddress = (token) => {
  return doGet(`${CUSTOMER}${ADDRESS}${LIST}`, token);
};

export const GetAllOrder = (currentPage, token) => {
  return doGet(`${CUSTOMER}${ORDER}${LIST}${"?page"}=${currentPage}`, token);
};

export const GetBlogDetails = (id) => {
  return doPost(`${BLOGS}${BLOG_DETAILS}/${id}`);
};

export const ContactUsApi = (data) => {
  return doPost(`${CONTACT}${CONTACTUS}`, data);
};

export const GetFrequentProducts = (id) => {
  return doGet(`${PRODUCTS}${FREQUENTLY_BOUGHT}${"?product_id"}=${id}`);
};

export const PostMakeDefaultAddress = (data, token) => {
  return doPost(`${CUSTOMER}${ADDRESS}${MAKE_DEFAULT}`, data, token);
};

export const PostPlaceOrder = (finalData, token) => {
  return doPost(`${CUSTOMER}${ORDER}${PLACE}`, finalData, token);
};

export const GetGiftCode = (data, token) => {
  return doGet(
    `${GIFT_CODE}${GET_GIFT_CODE}${"?giftCode"}=${data?.code}`,
    token
  );
};

export const GetCouponCode = (data, token) => {
  return doGet(
    `${COUPON}${APPLY}${"?code"}=${data?.code}${"&amount"}=${data?.amount}`,
    token
  );
};

export const PostDeleteAddress = (data, token) => {
  return doPost(`${CUSTOMER}${ADDRESS}${DELETE}`, data, token);
};

export const EditAddress = (data, token) => {
  return doPost(`${CUSTOMER}${ADDRESS}${EDIT_ADDRESS}`, data, token);
};

export const PostAddressApi = (data, token) => {
  return doPost(`${CUSTOMER}${ADDRESS}${ADD}`, data, token);
};

export const ResetPasswordApi = (data) => {
  return doPost(`${AUTH}${RESET_PASSWORD}`, data);
};

export const GetCustomerOrders = (currentPage, token) => {
  return doGet(`${CUSTOMER}${MY_BOOKINGS_LIST}${PAGE}=${currentPage}`, token);
};

export const GetCustomerMemberShip = (token, data) => {
  return doGet(
    data
      ? `${CUSTOMER}${GET_MEMBERSHIP}?id=${data}`
      : `${CUSTOMER}${GET_MEMBERSHIP}`,
    token
  );
};

export const getQRDetailsApiCall = (data) => {
  return doPost(`${MEMBERSHIP}${GET_MEMBERSHIP_BY_QR}`, data);
};

export const updateCSAMembership = (token, data) => {
  return doPost(`${MEMBERSHIP}${UPDATE_MEMBERSHIP}`, data, token);
};

export const cancelMemberShipApiCall = (token, data) => {
  return doPost(`${MEMBERSHIP}${CANCEL_MEMBERSHIP}`, data, token);
};

export const updateFamilyMemberDetailsApi = (token, data) => {
  return doPost(
    `${CUSTOMER}${MEMBERSHIP}${UPDATE_FAMILY_MEMBERSHIP}`,
    data,
    token
  );
};

export const ClearWishList = (id, token) => {
  return doDelete(
    `${CUSTOMER}${WISHLIST}${REMOVE_ALL}${CUSTOMER_ID}=${id}`,
    token
  );
};

export const forgotPasswordOtp = (data) => {
  return doPost(`${AUTH}${RESET_PASSWORD}`, data);
};

export const GetProductDate = () => {
  return doGet(`${PRODUCTS}${PRODUCT_DATE}`);
};

export const GetBookingDates = (membershipId, locationId) => {
  return doGet(
    `${MEMBERSHIP}/check-booking-dates?membership_id=${membershipId}&location_id=${locationId}`
  );
};
